function assert (condition, msg) {
  if (!condition) throw new Error(msg)
}

function install (options) {
  // 防止重复加载
  if (!install.installed) {
    install.installed = true
  } else {
    return
  }

  const script = document.createElement('script')
  script.src = options.src
  script.onload = () => {
    if (!window._czc) {
      console.error('加载umeng统计脚本失败，请检查src')
    }
  }
  document.body.appendChild(script)
}

install({
  src: 'https://s19.cnzz.com/z_stat.php?id=1274262492&web_id=1274262492'
})

export function trackEvent ({category, action, label, value, nodeid}) {
  assert(category && action, 'category和action不能为空')
  window._czc && window._czc.push(['_trackEvent', category, action, label, value, nodeid])
}



// WEBPACK FOOTER //
// ./src/umeng.js